import { FC } from 'react'

import clsx from 'clsx'

import { AppIcon } from 'shared/ui/app-icon'
import { AllIcons } from 'shared/ui/app-icon/types'
import { ImageOptimized } from 'shared/ui/image-optimized'

import { CreateObjectPhotoGridItem } from '../../types'

import s from './styles.module.scss'

interface PhotoGridCardProps {
  photo: CreateObjectPhotoGridItem
  disabled?: boolean
  onRemovePhoto?: (id: string) => void
  onPreviewPhoto?: (id: string) => void
}

export const PhotoGridCard: FC<PhotoGridCardProps> = ({
  photo,
  disabled,
  onRemovePhoto,
  onPreviewPhoto,
}) => {
  const isProcessing =
    photo.status === 'uploading' || photo.status === 'deleting'
  const canPreview = Boolean(onPreviewPhoto) && !disabled && !isProcessing
  const hasRemove = Boolean(onRemovePhoto)
  const canRemove = hasRemove && !disabled && !isProcessing

  const handlePreview = () => {
    if (!canPreview) return

    onPreviewPhoto?.(photo.id)
  }

  const handleRemove = () => {
    if (!canRemove) return

    onRemovePhoto?.(photo.id)
  }

  return (
    <div
      className={clsx(s.imageWrapper, {
        [s.uploading]: photo.status === 'uploading',
        [s.deleting]: photo.status === 'deleting',
        [s.error]: photo.status === 'error',
      })}
    >
      <button
        type="button"
        className={s.imageButton}
        aria-disabled={!canPreview}
        onClick={handlePreview}
      >
        <ImageOptimized
          className={s.image}
          src={photo.src}
          alt={photo.alt ?? ''}
        />
      </button>

      {hasRemove && (
        <button
          type="button"
          className={s.deleteButton}
          disabled={!canRemove}
          aria-label="Удалить фото"
          onClick={handleRemove}
        >
          <AppIcon
            id={AllIcons.REMOVE}
            width={12}
            height={12}
            color="var(--white)"
          />
        </button>
      )}

      {isProcessing && (
        <div className={s.loadingOverlay}>
          <div className={s.spinner} />
        </div>
      )}
    </div>
  )
}
